import React from 'react';
import ReactDOM from 'react-dom';

export default function autoFocus(Component) {
    class AutoFocus extends React.Component {
        maybeFocus() {
            if (this.props.isFocused) {
                ReactDOM.findDOMNode(this).focus();
            }
        }

        componentDidMount() {
            this.maybeFocus();
        }

        componentDidUpdate(prevProps) {
            if (this.props.isFocused != prevProps.isFocused) {
                this.maybeFocus();
            }
        }

        render() {
            const props = Object.assign({}, this.props);
            delete props.isFocused;
            return <Component {...props} />;
        }
    }

    AutoFocus.displayName = `autoFocus(${Component.name})`;

    return AutoFocus;
}



// WEBPACK FOOTER //
// ./~/@99designs/react-components/lib/hoc/autoFocus.js